var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showScrollDown)?_c('v-icon',{staticClass:"scroll-down",attrs:{"color":"error","x-large":""}},[_vm._v("mdi-chevron-down")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }